import {useMutation} from "@tanstack/react-query";

import {removeMaterialFunctionMutationOptions} from "./remove-material-function.mutation-options";

export function useRemoveMaterialFunction(id: string) {
  return useMutation(removeMaterialFunctionMutationOptions(id));
}
